import { render } from "./SnoreLevel.vue?vue&type=template&id=8e162ce0&scoped=true&ts=true"
import script from "./SnoreLevel.vue?vue&type=script&lang=ts"
export * from "./SnoreLevel.vue?vue&type=script&lang=ts"

import "./SnoreLevel.vue?vue&type=style&index=0&id=8e162ce0&scoped=true&lang=less"

import exportComponent from "/var/jenkins_home/workspace/mobile-mpe-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e162ce0"]])

export default __exports__